import { usePlacesAutocomplete } from "hooks/usePlacesAutocomplete";
import { useState } from "react";
import { Control } from "react-hook-form";
import CustomFormAutoComplete from "components/inputs/CustomFormAutoComplete/CustomFormAutoComplete";


interface Props {
  name: string;
  control: Control<any>;
  onChange?: (name: string) => void;
}

export default function PlacesSearch({
  name,
  control,
  onChange,
}: Props) {
  const [inputValue, setInputValue] = useState("");
  const suggestions = usePlacesAutocomplete(inputValue);

  const stringOptions = suggestions.map(
    (s) => s.placePrediction?.text?.text ?? ""
  );

  return (
    <CustomFormAutoComplete<string>
      name={name}
      control={control}
      options={stringOptions}
      loading={!!inputValue && suggestions.length === 0}
      placeholder="Institution"
      floatingLabel="Institution"
      required
      getOptionLabel={(option) => option || ""}
      isOptionEqualToValue={(option, value) => option === value}
      onInputChange={(_, value) => {
        setInputValue(value);
      }}
      onOptionChange={(value: string | null) => {
        if (!value) return;
        onChange?.(value);
      }}
    />
  );
}
